<template>
  <div class="pdf container">
    <div class="box">
      <el-page-header @back="$router.go(-1)" content="课程实训任务">
      </el-page-header>
      <el-button
        class="go-btn"
        type="primary"
        size="small"
        @click="
          $router.push({
            path: '/courseDetail/practice/uploadWorks',
            query: {
              ...$route.query,
              worksId:
                $route.query.worksStatus == 'REDO'
                  ? $route.query.worksId
                  : null,
            },
          })
        "
        :disabled="$route.query.worksStatus == 'SUBMITTED'"
        >提交作品</el-button
      >
      <el-dropdown class="download-btn">
        <el-button type="primary" icon="el-icon-download" size="small"
          >下载</el-button
        >
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            ><a :href="pdfSrc" download>PDF下载</a></el-dropdown-item
          >
          <el-dropdown-item
            ><a :href="wordSrc" download>word下载</a></el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
      <object :data="pdfSrc" type="application/pdf" class="pdf-area">
        <iframe :src="pdfSrc" width="100%" height="100%" style="border: none">
          浏览器不支持PDF预览，请先下载PDF: <a :href="pdfSrc">下载 PDF</a>
        </iframe>
      </object>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: Object,
  },
  watch: {
    info(val) {
      this.pdfSrc = val.pdfLink;
      this.wordSrc = val.wordLink;
    },
  },
  data() {
    return {
      pdfSrc: this.info.pdfLink,
      wordSrc: this.info.wordLink,
    };
  },
};
</script>

<style lang="less" scoped>
.pdf {
  position: relative;
  height: 100%;
  text-align: left;
  .box {
    position: relative;
    padding: 25px 35px;
    margin: 30px auto;
    height: calc(100% - 60px);
    background-color: #fff;
    ::v-deep .el-page-header {
      margin-bottom: 20px;
      .el-page-header__content {
        font-size: 16px;
      }
    }
  }
  .go-btn,
  .download-btn {
    position: absolute;
    top: 25px;
    &.go-btn {
      right: 35px;
    }
    &.download-btn {
      right: 120px;
    }
  }
  .pdf-area {
    width: 100%;
    height: calc(100% - 44px);
  }
}
</style>